<template>
  <div class="basic-container container">
    <div class="basic-info-group basic-info-item">
      <span class="basic-title">急救事例：</span>
      <div class="basic-info">
        <el-row class="info-row">
          <el-col :span="3" class="info-key">对象：</el-col>
          <el-col :span="5" class="info-item">
            {{
              form.ambulance?.name + "-" + form.ambulance?.idName
            }}
          </el-col>
          <el-col :span="3" :offset="1" class="info-key">事例编号：</el-col>
          <el-col :span="4" class="info-item">{{ form.number }}</el-col>
          <el-col :span="3" :offset="1" class="info-key">时间：</el-col>
          <el-col :span="4" class="info-item">{{ form.formatTime }}</el-col>
        </el-row>
        <el-row class="info-row">
          <el-col :span="2" class="info-key">主诉：</el-col>
          <el-col :span="21" :offset="1" class="info-item">{{ form.mainComplaint }}</el-col>
        </el-row>
      </div>
    </div>
    <div class="connect-patient basic-info-item">
      <span class="basic-title">事件关联：</span>
      <div class="connect-info">
        <!--  查看页面  -->
        <div v-if="isShowPatient">
          <div v-if="!isConnect" class="line"/>
          <div v-else>
            <el-row class="history">
              <el-col :span="4" class="info-key">主题：</el-col>
              <el-col :span="14" :offset="1">
                {{ form?.nobody_medicalstatus?.subject }}
              </el-col>
            </el-row>
            <el-row class="history">
              <el-col :span="4" class="info-key">事例编号：</el-col>
              <el-col :span="16" :offset="1">
                {{ form?.nobody_medicalstatus?.medicalhistory_numbers }}
              </el-col>
            </el-row>
          </div>
        </div>
        <!--   可以编辑页面     -->
        <div v-else class="basic-info">
          <el-row class="info-row">
            <el-col :span="4" class="info-key">主题：</el-col>
            <el-col :span="14" :offset="1" class="info-key">
              <el-input v-model="form.nobody_medicalstatus.subject"/>
            </el-col>
          </el-row>
          <el-row class="history">
            <el-col :span="4" class="info-key">事例编号:</el-col>
            <el-col :span="16" :offset="1">
              <el-input v-model="form.nobody_medicalstatus.medicalhistory_numbers" placeholder="输入相关的事例编号，以”,”隔开"/>
            </el-col>
          </el-row>
          <!--          <el-button class="connect-button">{{ buttonText }}</el-button>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BasicInfo",
  components: {},
  data() {
    return {
      isConnect: false, // 是否关联
      form: {
        ambulance: {},
        number: "",
        formatTime: "",
        mainComplaint: "",
        nobody_medicalstatus: {
          subject: ""
        }
      },
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    // buttonText() {
    //   return this.isConnect ? "重新关联" : "关联";
    // },
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    }
  },
  watch: {
    patient: {
      handler(val) {
        const { ambulance, number, formatTime, mainComplaint, nobody_medicalstatus } = val;
        // console.log(nobody_medicalstatus);
        let info = {};
        if (nobody_medicalstatus.length) {
          info = nobody_medicalstatus[0];
        } else {
          info = {
            subject: "",
            medicalhistory_numbers: ""
          };
        }
        this.form = {
          ambulance, number, formatTime, mainComplaint,
          nobody_medicalstatus: info
        };
        console.log(this.form);
        if (info.subject || info.medicalhistory_numbers) {
          this.isConnect = true;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-container {
  display: flex;
  background: #f0f5f7;
  padding: 0;
}

// 分区主体
.basic-info-group {
  width: 1000px; // 这里要给宽度
  background: #FFFFFF; // 给背景色
  border-radius: 10px;
  padding: 24px 36px 12px;
  flex: 1;
  min-width: 800px;
}

.basic-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)
}

.basic-info-item {
  padding: 24px 36px;
  background-color: #ffffff;
  border-radius: 10px;
}

.connect-patient {
  width: 592px;
  margin-left: 20px; // 与另外一块区域分离
  position: relative;
}

.connect-info {
  width: 100%;

  .connect-button {
    height: 32px;
    min-height: 32px;
    border: 1px solid #2AA5E3;
    border-radius: 10px;
    font-size: 16px;
    color: #2AA5E3;
    padding: 6px 12px;
    float: right;
  }

  ::v-deep .el-input__inner {
    width: 280px;
    height: 32px;
    border: 1px solid #999999;
    border-radius: 10px;
  }

  .line {
    width: 520px;
    height: 1px;
    background: #CCCCCC;
    position: absolute;
    top: 50%;
  }
}

.history {
  margin-top: 12px;
  align-items: center;

  > div {
    font-size: 16px;
    color: #333333;
    line-height: 28px;
  }
}
</style>
